import React from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import myImg from '../../Assets/avatar.svg'
import Tilt from 'react-parallax-tilt'
import {AiFillGithub} from 'react-icons/ai'
import {FaLinkedinIn, FaInstagram} from 'react-icons/fa'

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{fontSize: '2.6em'}}>
              LET'S <span className="purple"> GET </span> FAMILIAR
            </h1>
            <p className="home-about-body">
            I have developed a deep passion for programming and have acquired substantial knowledge and skills in different programming languages.
              <br />
              <br />I am fluent in
              <i>
                <b className="purple"> Python Programming Language with Machine Learning. </b>
              </i>
              <br />
              <br />
              My interests lie in developing and automating solutions using &nbsp;
              <i>
                <b className="purple">
                  Machine Learning, Artificial Intelligence {' '}
                </b>{' '} and <b className="purple">
                  Deep Learning {' '}
                </b>{' '}
                with a strong focus on <b className="purple">Cloud technologies.</b>
              </i>
              <br />
              <br />
              {/* Whenever possible, I also apply my passion for learning and developing products */}
              {/* with <b className="purple">Node.js</b> and */}
              {/* <i>
                <b className="purple">
                  {' '}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i> */}
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Amaan-AeonX"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/amaan-akbany5/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/maverick_520/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  )
}
export default Home2
